export enum permissionOverrideEnum {
  READ = 'read',
  WRITE = 'write',
  NO_ACCESS = 'no-access',
}
